import { IsNotEmpty, IsString } from 'class-validator';

export class Bs2IntegracaoTopicDto {
  @IsString()
  @IsNotEmpty()
  integracaoId: string;
}
